"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.menuReducer = menuReducer;
var _useList = require("../useList");
function menuReducer(state, action) {
    if (action.type === _useList.ListActionTypes.itemHover) {
        return _object_spread_props(_object_spread({}, state), {
            highlightedValue: action.item
        });
    }
    var newState = (0, _useList.listReducer)(state, action);
    // make sure an item is always highlighted
    if (newState.highlightedValue === null && action.context.items.length > 0) {
        return _object_spread_props(_object_spread({}, newState), {
            highlightedValue: action.context.items[0]
        });
    }
    if (action.type === _useList.ListActionTypes.keyDown) {
        if (action.event.key === 'Escape') {
            return _object_spread_props(_object_spread({}, newState), {
                open: false
            });
        }
    }
    if (action.type === _useList.ListActionTypes.blur) {
        var _action_context_listboxRef_current;
        if (!((_action_context_listboxRef_current = action.context.listboxRef.current) === null || _action_context_listboxRef_current === void 0 ? void 0 : _action_context_listboxRef_current.contains(action.event.relatedTarget))) {
            var _action_context_listboxRef_current1, _action_event_relatedTarget;
            // To prevent the menu from closing when the focus leaves the menu to the button.
            // For more details, see https://github.com/mui/material-ui/pull/36917#issuecomment-1566992698
            var listboxId = (_action_context_listboxRef_current1 = action.context.listboxRef.current) === null || _action_context_listboxRef_current1 === void 0 ? void 0 : _action_context_listboxRef_current1.getAttribute('id');
            var controlledBy = (_action_event_relatedTarget = action.event.relatedTarget) === null || _action_event_relatedTarget === void 0 ? void 0 : _action_event_relatedTarget.getAttribute('aria-controls');
            if (listboxId && controlledBy && listboxId === controlledBy) {
                return newState;
            }
            return _object_spread_props(_object_spread({}, newState), {
                open: false,
                highlightedValue: action.context.items[0]
            });
        }
    }
    return newState;
}
